// core components
// import Dashboard from "views/admin/Dashboard.js";
// import Icons from "views/admin/Icons.js";
// import Login from "views/auth/Login.js";
// import Maps from "views/admin/Maps.js";
// import Profile from "views/admin/Profile.js";
// import Register from "views/auth/Register.js";
// import Tables from "views/admin/Tables.js";

import Home from "./containers/home";
import Project from "./containers/project";
import ProjectDetail from "./containers/project_detail";
import Issues from "./containers/issues";
import issueDetail from "./containers/issue_detail";
import Tasks from "./containers/tasks";
import Search from "./containers/search";

// @material-ui/icons components
import HomeTwoTone from "@material-ui/icons/HomeTwoTone";
import AccountTreeTwoTone from "@material-ui/icons/AccountTreeTwoTone";
import FormatListBulleted from "@material-ui/icons/FormatListBulleted";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import SearchIcon from "@material-ui/icons/Search";

export const routes = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "/projects",
    component: Project,
  },
  {
    path: "/project/issues",
    component: Issues,
  },
  {
    path: "/project/:id",
    component: ProjectDetail,
  },
  {
    path: "/project/:id/issues",
    component: Issues,
  },
  {
    path: "/issue/:id",
    component: issueDetail,
  },
  {
    path: "/tasks",
    component: Tasks,
  },
  {
    path: "/search",
    component: Search,
  },
];

export const sidebarItems = [
  {
    path: "/",
    name: "label_home",
    icon: HomeTwoTone,
    iconColor: "Primary",
  },
  {
    path: "/projects",
    name: "label_projects",
    icon: AccountTreeTwoTone,
    iconColor: "Info",
  },
  {
    path: "/project/:id/issues",
    name: "label_issues",
    icon: FormatListBulleted,
    iconColor: "Warning",
  },
  {
    path: "/tasks",
    name: "label_tasks",
    icon: PlaylistAddCheckIcon,
    iconColor: "PrimaryLight",
  },
  {
    path: "/search",
    name: "label_search",
    icon: SearchIcon,
    iconColor: "Success",
  },
];
